import React, { useState, useEffect, useRef } from "react";
import { Backdrop, CircularProgress, Button } from "@mui/material";
import { useNavigate,Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Table, BarChart } from "react-bootstrap-icons"
import "./table.css";
import Select from "react-select";
import { MdRefresh } from "react-icons/md";
import { TabView, TabPanel } from "primereact/tabview";
import { MdNotificationsActive } from "react-icons/md";
import { BlobServiceClient } from "@azure/storage-blob";
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
const ESGBenchmarking = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    companyName: [],
    sector: [],
    country: [],
    competitors: [],
    year: [],
  });
  const [viewMode, setViewMode] = useState("table")
  const [data, setData] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [competitorsOptions, setCompetitorsOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [nextToken, setNextToken] = useState(null);
  const [tab3total, setTab3Total] = useState();
  const [tab2total, setTab2Total] = useState();
  const [searchText, setSearchText] = useState("");
  const [fontSize, setFontSize] = useState(window.innerWidth >= 1400 ? "15px" : "13px");
  const username = localStorage.getItem("userName");

  const resetSelections = () => {
    setFormData({
      companyName: null, // ✅ Change from [] to null for clearing the dropdown
      sector: [],
      country: [],
      competitors: [],
      year: "",
    });
    setSearchText(""); 
    setFilteredEmissionsData([]);
    setFilteredTargetsData([]);
    setFilteredReportingData([]);
  };

  const [filteredEmissionsData, setFilteredEmissionsData] = useState([]);
  const [filteredTargetsData, setFilteredTargetsData] = useState([]);
  const [filteredReportingData, setFilteredReportingData] = useState([]);

  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    // Trigger the file input click
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    // Access the uploaded files
    const files = event.target.files;
    if (files.length > 0) {
      console.log("Files selected:", files);
      // Add logic to handle file upload
    }
  };

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    company: { value: null, matchMode: FilterMatchMode.CONTAINS },
    sector: { value: null, matchMode: FilterMatchMode.CONTAINS },
    country: { value: null, matchMode: FilterMatchMode.CONTAINS },
    year: { value: null, matchMode: FilterMatchMode.CONTAINS },
    revenue: { value: null, matchMode: FilterMatchMode.CONTAINS },
    employees: { value: null, matchMode: FilterMatchMode.CONTAINS },
    scope1: { value: null, matchMode: FilterMatchMode.CONTAINS },
    scope2: { value: null, matchMode: FilterMatchMode.CONTAINS },
    scope3: { value: null, matchMode: FilterMatchMode.CONTAINS },
    totalEmissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    economicEmissionIntensity: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [emissionsData, setEmissionsData] = useState([]);
  const [targetsData, setTargetsData] = useState([]);
  const [reportingData, setReportingData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(1);
  const [companyFilter, setCompanyFilter] = useState("");
  const [sectorFilter, setSectorFilter] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
  const [yearFilter, setYearFilter] = useState("");
  const [competitorFilter, setCompetitorFilter] = useState([]);

  const yesNoOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  useEffect(() => {
    fetchDatas();
    onPageLoadFilter();
  }, [formData]);

  // Determine if filters are applied
  const isFilterApplied = Object.values(formData).some((value) => value);

  const fetchDatas = async () => {
    setLoading(true);
    try {
      // Ensure companyName is a string or null
      const companyName = typeof formData.companyName === 'string' ? formData.companyName : null;
      
      const requestBody = {
        companyNames: companyName ? [companyName] : [],
        sectors: Array.isArray(formData.sector) ? formData.sector : [],
        countries: Array.isArray(formData.country) ? formData.country : [],
        competitors: Array.isArray(formData.competitors) ? formData.competitors : [],
        years: formData.year ? (Array.isArray(formData.year) ? formData.year.map(year => Number(year)) : [Number(formData.year)]) : []
      };

      // Log the request body for debugging
      console.log('Request Body:', requestBody);
      console.log('Form Data:', formData);

      const apiRequests = [
        {
          url: `${process.env.REACT_APP_BASE_API_URL}emission-targets`,
          body: requestBody,
          setData: setTargetsData,
        },
      ];
      // Make concurrent requests
      const responses = await Promise.all(
        apiRequests.map(({ url, body }) =>
          fetch(url, {
            method: "POST",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              username,
            },
            body: JSON.stringify(body),
          })
        )
      );
      // Process the responses
      await Promise.all(
        responses.map(async (res, index) => {
          const { setData } = apiRequests[index];
          if (res.status === 200) {
            const responseJson = await res.json();
            // Ensure we're setting an array
            setData(Array.isArray(responseJson) ? responseJson : []);
            setLoading(false);
          } else {
            console.error(`Error with API: ${apiRequests[index].url}`);
            setData([]); // Set empty array on error
            setLoading(false);
          }
        })
      );
    } catch (error) {
      console.error("Error", error);
      setTargetsData([]); // Set empty array on error
      setLoading(false);
    } 
  };

  const onDropdownChange = (e, rowData, field) => {
    const updatedData = targetsData.map((row) => {
      if (row === rowData) {
        return { ...row, [field]: e.value };
      }
      return row;
    });
    setTargetsData(updatedData);
  };

  const onInputChange = (e, rowData, field) => {
    const updatedData = targetsData.map((row) => {
      if (row === rowData) {
        return { ...row, [field]: e.target.value };
      }
      return row;
    });
    setTargetsData(updatedData);
  };

  const netZeroTargetTemplate = (rowData) => {
    return <Dropdown value={rowData.netZeroTarget} options={yesNoOptions} onChange={(e) => onDropdownChange(e, rowData, "netZeroTarget")} placeholder="Yes/No" />;
  };

  const nearTermTargetTemplate = (rowData) => {
    return <InputNumber value={rowData.nearTermTarget} onValueChange={(e) => onInputChange(e, rowData, "nearTermTarget")} placeholder="Enter Value" />;
  };

  const targetStatementTemplate = (rowData) => {
    return <InputText value={rowData.targetStatement} onChange={(e) => onInputChange(e, rowData, "targetStatement")} placeholder="Enter statement" />;
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setFilters((prevFilters) => ({
      ...prevFilters,
      global: { value: value, matchMode: FilterMatchMode.CONTAINS },
    }));
    setGlobalFilterValue(value);
  };

  

  const onPageLoadFilter = async () => {
    const e = activeIndex;
    // Reset filters for the newly selected tab
    const requestBody1 = {
      companyNames: formData.companyName?.length > 1 ? [formData.companyName] : [],
      sectors: Array.isArray(formData.sector) ? formData.sector : [],
      countries: Array.isArray(formData.country) ? formData.country : [],
      competitors: Array.isArray(formData.competitors) ? formData.competitors : [],
      years: formData.year ? (Array.isArray(formData.year) ? formData.year.map(year => Number(year)) : [Number(formData.year)]) : []
    };
    console.log(formData);

    setLoading(true);
    try {
      let url = "";
      let requestBody = {};
      // Determine API and request body based on the active tab
      
      url = `${process.env.REACT_APP_BASE_API_URL}emission-targets-filter`;
      requestBody = requestBody1;
      

      // Fetch data for the selected tab
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username,
        },
        body: JSON.stringify(requestBody),
      });

      if (res.status === 200) {
        const responseJson = await res.json();
        // Update the data state based on the active tab
        console.log("Targets");
        setCompanyOptions(responseJson.companyNames.map((name) => ({ label: name, value: name })));
        setSectorOptions(responseJson.sectors.map((name) => ({ label: name, value: name })));
        setCountryOptions(responseJson.countries.map((name) => ({ label: name, value: name })));
        const competitorsOptions = Object.entries(responseJson.competitors).map(([name, isSelected]) => ({
          label: name,
          value: name,
          selected: isSelected, // true if the value is true, false otherwise
        }));
        setCompetitorsOptions(competitorsOptions);
        setYearOptions(responseJson.years.map((name) => ({ label: name, value: name })));
        
      } else {
        console.error(`Error fetching data for tab index ${e.index}`);
      }
    } catch (error) {
      console.error("Error", error);
    } 
  };

  

  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <span className="p-input-icon-left">
          <img src="assets/img/search.png" className="search-i" alt="search" />
          <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
        </span>
      </div>
    );
  };

  const header = renderHeader();

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: "#00366D26",
      background: "#F5F5F5",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#407775", // Change border color on hover
      },
      fontSize: fontSize, // Set font size for control (including selected option)
      color: "#707070!important", // Set default text color for the control
      paddingLeft:
        state.selectProps.name === "companyName" && (!formData.companyName || formData.companyName.length === 0)
          ? "30px"
          : state.selectProps.name === "sector" && (!formData.sector || formData.sector.length === 0)
          ? "30px"
          : state.selectProps.name === "region" && (!formData.region || formData.region.length === 0)
          ? "30px"
          : state.selectProps.name === "country" && (!formData.country || formData.country.length === 0)
          ? "30px"
          : state.selectProps.name === "competitors" && (!formData.competitors || formData.competitors.length === 0)
          ? "30px"
          : state.selectProps.name === "year" && (!formData.year || formData.year.length === 0)
          ? "30px"
          : "0px", // Default padding if the field is filled
      position: "relative",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#707070",
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      "&:hover": {
        color: "#707070", // Change border color on hover
      },
    }),
    indicatorSeparator: () => ({
      display: "none", // Hide the separator
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure the menu is above other elements
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused || state.isSelected ? "#eef1f5" : "white", // Hover and selected background color
      color: state.isSelected ? "#407775" : "#707070", // Change text color for selected options
      fontSize: fontSize, // Use fontSize state variable for options
      "&:active": {
        backgroundColor: "#eef1f5", // Change color on active (click)
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: fontSize, // Set font size for the placeholder
      color: "#707070", // Set placeholder color
    }),
  }; 

  return (
    <div id="wrapper">
      {loading && (
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <div id="">
        <header>
          <nav className="navbar navbar-expand-lg navbar-light" style={{ background: "#407775" }}>
            <div className="container-fluid  mx-4 my-2">
              <div className="d-flex align-items-center">
                <a className="navbar-brand d-flex align-items-center p-0" href="#home">
                  <img src="assets/img/logo.png" alt="Company Logo" height="30" />
                </a>
                <div
                  className="mx-2"
                  style={{
                    borderLeft: "1px solid #fff",
                    height: "30px",
                    paddingLeft: "20px",
                    opacity: "0.5",
                  }}
                ></div>
                <span className="text-white" style={{ opacity: "0.7", fontSize: "14px" }}>
                  Organization Name
                </span>
              </div>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul className="navbar-nav mb-2 mb-lg-0 d-flex align-items-center">
                  <li className="nav-item">
                    <a className="nav-link  text-white" href="#notifications">
                      <MdNotificationsActive className="icon" style={{ width: "1.5rem", height: "1.5rem" }} />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link text-white" href="#profile">
                      <img className="icon mr-2" src="assets/img/User.png" alt="User" />
                    </a>
                  </li>
                  <li className="nav-item">
                    <span className="text-white" style={{ opacity: "0.7", fontSize: "14px" }}>
                      XYZ ltd
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>

        <div className="container survey-form scf p-4 p-lg-5">
          <div className="row">
            <div className="col">
              <Link to="/esg-benchmarking" style={{ color: "#407775", fontSize: "14px", textDecoration: "none" }}>
                Home
              </Link>
            </div>
          </div>
          <div className="row my-4">
            <div className="col">
              <div className="form-header d-flex justify-content-between">
                <h1 className="title" style={{ color: "#494949" }}>
                  Emission Targets
                </h1>
                <Button className="refresh-cta" onClick={resetSelections} variant="text" startIcon={<MdRefresh />}>
                  Reset Filters
                </Button>
              </div>
            </div>
          </div>
          <div className="form-part">
            <form>
              <div className="row gx-2 gy-3">
                <div className="col-xl-2 col-lg-4 col-md-6">
                  <label className="formlable">Company Name</label>
                  <div className="input-group position-relative">
                    {(!formData.companyName || formData.companyName.length === 0) && (
                      <span className="search-icon">
                        <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                      </span>
                    )}
                    <Select
                      name="companyName"
                      value={formData.companyName ? { label: formData.companyName, value: formData.companyName } : null}
                      options={companyOptions}
                      onChange={(selectedOption) => {
                        console.log('Selected Company:', selectedOption);
                        setFormData({
                          ...formData,
                          companyName: selectedOption ? selectedOption.value : null
                        });
                      }}
                      placeholder="Search"
                      isSearchable
                      styles={customStyles}
                      className="custom-select-with-icon wd-100"
                    />

                  </div>
                </div>

                <div className="col-xl-2 col-lg-4 col-md-6">
                  <label className="formlable">Sector</label>
                  <div className="input-group position-relative">
                    {(!formData.sector || formData.sector.length === 0) && ( // Conditionally render the search icon
                      <span className="search-icon">
                        <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                      </span>
                    )}
                    <Select
                      name="sector"
                      value={sectorOptions.filter((option) => formData.sector?.includes(option.value))}
                      options={sectorOptions}
                      onChange={(selectedOptions) => {
                        if (selectedOptions.length <= 5) {
                          setFormData({
                            ...formData,
                            sector: selectedOptions.map((opt) => opt.value),
                          });
                        }
                      }}
                      placeholder="Search"
                      isMulti
                      isSearchable
                      styles={customStyles}
                      className="custom-select-with-icon wd-100"
                      maxMenuHeight={200} // Limit dropdown height if needed
                    />
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-md-6">
                  <label className="formlable">Country</label>
                  <div className="input-group position-relative">
                    {(!formData.country || formData.country.length === 0) && ( // Conditionally render the search icon
                      <span className="search-icon">
                        <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                      </span>
                    )}
                    <Select
                      name="country"
                      value={countryOptions.filter((option) => formData.country?.includes(option.value))}
                      options={countryOptions}
                      onChange={(selectedOptions) => {
                        if (selectedOptions.length <= 5) {
                          setFormData({
                            ...formData,
                            country: selectedOptions.map((opt) => opt.value),
                          });
                        }
                      }}
                      placeholder="Search"
                      isMulti
                      isSearchable
                      styles={customStyles}
                      className="custom-select-with-icon wd-100"
                      maxMenuHeight={200} // Limit dropdown height if needed
                    />
                  </div>
                </div>

                <div className="col-xl-2 col-lg-4 col-md-6">
                  <label className="formlable">
                    Select Competitors <span style={{ fontSize: "10px" }}>(Upto 5)</span>
                  </label>
                  <div className="input-group position-relative">
                    {(!formData.competitors || formData.competitors.length === 0) && (
                      <span className="search-icon">
                        <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                      </span>
                    )}
                    <Select
                      name="competitors"
                      value={competitorsOptions.filter((option) => formData.competitors?.includes(option.value))}
                      options={competitorsOptions}
                      onChange={(selectedOptions) => {
                        console.log("Selected Competitors:", selectedOptions);
                        console.log("Form Data:", formData);
                        if (selectedOptions.length <= 5) {
                          setFormData({
                            ...formData,
                            competitors: selectedOptions.map((opt) => opt.value),
                          });
                        }
                      }}
                      placeholder="Search"
                      isMulti
                      isSearchable
                      styles={customStyles}
                      className="custom-select-with-icon wd-100"
                      maxMenuHeight={200} // Limit dropdown height if needed
                    />
                  </div>
                </div>
                {activeIndex !== 2 && (
                  <div className="col-xl-2 col-lg-4 col-md-6">
                    <label className="formlable">Year</label>
                    <div className="input-group position-relative">
                      {(!formData.year || formData.year.length === 0) && (
                        <span className="search-icon">
                          <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                        </span>
                      )}
                      <Select
                        name="year"
                        value={formData.year ? yearOptions.find((option) => option.value === formData.year) : null}
                        options={yearOptions}
                        onChange={(e) => setFormData({ ...formData, year: e.value })}
                        placeholder="Search"
                        isSearchable
                        styles={customStyles}
                        className="custom-select-with-icon wd-100"
                      />
                    </div>
                  </div>
                )}
              </div>
           
       

       

              <div className="row tabs mt-5">
                
                    <div className="data-responsive">
                      <DataTable
                        value={Array.isArray(targetsData) ? targetsData : []}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 20, 25, 50]}
                        scrollable
                        scrollDirection="horizontal"
                        tableStyle={{ minWidth: "50rem" }}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        emptyMessage="No data found."
                      >
                        <Column field="companyName" header="Company" sortable style={{ width: "10%" }} />
                        <Column field="sector" header="Sector" sortable style={{ width: "10%" }} />
                        <Column field="country" header="Country" sortable style={{ width: "10%" }} />
                        <Column field="netZeroCommitted" header="Net Zero target" style={{ width: "10%" }} />
                        <Column field="netZeroYear" header="Net Zero year" sortable style={{ width: "10%" }} />
                        <Column field="nearTermTargetStatus" header="Near-term target" style={{ width: "10%" }} />
                        <Column field="nearTermTargetYear" header="Near-term target year" sortable style={{ width: "10%" }} />
                        <Column field="targetClassification" header="Target statement" style={{ width: "20%" }} />
                        <Column field="date" header="Update date" sortable style={{ width: "10%" }} />
                      </DataTable>
                    </div>
                
              </div>
           
        
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ESGBenchmarking;
